export interface TvEpisode {
  id: string;
  title: string;
  episodeNumber: number;
  duration: string;
}

export interface TvShow {
  id: string;
  title: string;
  englishTitle: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  description: string;
  longDescription: string;
  poster: string;
  cover: string;
  status: '更新中' | '已完结';
  updateInfo: string;
  totalEpisodes: number;
  currentEpisode: number;
  director: string;
  cast: string[];
  region: string;
  language: string;
  genres: string[];
  episodes: TvEpisode[];
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
  views: string;
}

export const tvShows: TvShow[] = [
  {
    id: '1',
    title: '长相思',
    englishTitle: 'Lost You Forever',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 8.9,
    description: '上古时期，人神妖混居，皓翎国王姬玖瑶（小夭）历经百年颠沛流离，失去了身份和容貌，在清水镇落脚化身玟小六，悬壶济世。',
    longDescription: '上古时期，人神妖混居，皓翎国王姬玖瑶（小夭）历经百年颠沛流离，失去了身份和容貌，在清水镇落脚化身玟小六，悬壶济世。期间她救了被兄长迫害的青丘公子涂山璟,并在朝夕相处中二人情愫渐生。同时她又与九头妖相柳不打不相识，惺惺相惜结为知己。而她的表哥轩辕王子玱玹为了寻找小夭走遍大荒，终于在清水镇相遇。上古命运之轮开始转动，一段跨越千年的爱恨纠葛就此展开。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20costume%20drama%20poster%2C%20elegant%20woman%20in%20traditional%20red%20hanfu%20dress%20with%20flowing%20sleeves%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20misty%20ancient%20Chinese%20landscape%20background%2C%20warm%20golden%20tones%2C%20high%20quality%20film%20poster%20style&width=600&height=840&seq=tv-poster-01&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20fantasy%20drama%20cinematic%20wide%20banner%2C%20ancient%20Chinese%20palace%20and%20misty%20mountains%2C%20warm%20golden%20hour%20lighting%2C%20dramatic%20atmosphere%2C%20film%20grain%20texture%2C%20rich%20red%20and%20gold%20color%20palette%2C%20artistic%20composition&width=1600&height=700&seq=tv-cover-01&orientation=landscape',
    status: '更新中',
    updateInfo: '更新至38集/共45集',
    totalEpisodes: 45,
    currentEpisode: 38,
    director: '秦榛',
    cast: ['杨紫', '张晚意', '邓为', '檀健次', '代露娃'],
    region: '中国大陆',
    language: '汉语普通话',
    genres: ['古装', '爱情', '奇幻'],
    episodes: Array.from({ length: 45 }, (_, i) => ({
      id: `ep-1-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '45分钟',
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
    views: '1280万',
  },
  {
    id: '2',
    title: '我的人间烟火',
    englishTitle: 'Fireworks of My Heart',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 8.3,
    description: '消防站长宋焰和急诊科医生许沁分别十年后重逢，两人压抑着对彼此的爱意，在一次次生死救援中重新靠近。',
    longDescription: '消防站长宋焰和急诊科医生许沁分别十年后重逢，两人压抑着对彼此的爱意，在一次次生死救援中重新靠近。青春时代的两人因家庭反对被迫分开，再次相遇,宋焰已成为守护城市的消防英雄，许沁也成长为独当一面的急诊医生。在一次次血与火的救援行动中，两人逐渐打破隔阂，携手守护这座城市。',
    poster: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20romance%20drama%20poster%2C%20firefighter%20and%20female%20doctor%20in%20uniform%2C%20warm%20city%20night%20lights%20background%2C%20romantic%20cinematic%20lighting%2C%20professional%20urban%20drama%20aesthetic%2C%20warm%20orange%20and%20teal%20color%20tones&width=600&height=840&seq=tv-poster-02&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20firefighter%20drama%20cinematic%20wide%20banner%2C%20city%20skyline%20at%20sunset%20with%20fire%20truck%20silhouette%2C%20dramatic%20warm%20lighting%2C%20heroic%20atmosphere%2C%20professional%20film%20photography%2C%20orange%20and%20gold%20tones&width=1600&height=700&seq=tv-cover-02&orientation=landscape',
    status: '已完结',
    updateInfo: '全40集',
    totalEpisodes: 40,
    currentEpisode: 40,
    director: '李木戈',
    cast: ['杨洋', '王楚然', '魏大勋', '王彦霖'],
    region: '中国大陆',
    language: '汉语普通话',
    genres: ['都市', '爱情', '职业'],
    episodes: Array.from({ length: 40 }, (_, i) => ({
      id: `ep-2-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '45分钟',
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
    views: '980万',
  },
  {
    id: '3',
    title: '请回答1988',
    englishTitle: 'Reply 1988',
    category: '韩剧',
    categorySlug: 'hanju',
    year: 2015,
    rating: 9.7,
    description: '讲述1988年首尔双门洞五个家庭的故事，描绘温暖的亲情、邻里街坊小市民传统的爱情与友情。',
    longDescription: '讲述1988年首尔双门洞五个家庭的故事，描绘温暖的亲情、邻里街坊小市民传统的爱情与友情。故事以1988年汉城奥运会为背景，讲述了住在首尔市道峰区双门洞的五个家庭之间发生的温暖故事。五个家庭的孩子德善、善宇、东龙、崔泽、正焕，是从小一起长大的好朋友，故事围绕他们的青春成长展开。',
    poster: 'https://readdy.ai/api/search-image?query=Korean%20nostalgic%20drama%20poster%20Reply%201988%20style%2C%20group%20of%20young%20friends%20in%201980s%20retro%20Korean%20clothing%2C%20warm%20vintage%20film%20aesthetic%2C%20nostalgic%20neighborhood%20alley%20background%2C%20soft%20warm%20tones%2C%20friendship%20and%20family%20theme&width=600&height=840&seq=tv-poster-03&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Korean%201980s%20nostalgic%20neighborhood%20wide%20cinematic%20banner%2C%20warm%20evening%20alley%20with%20traditional%20Korean%20houses%2C%20vintage%20aesthetic%2C%20soft%20golden%20hour%20light%2C%20retro%20film%20photography%20style%2C%20warm%20and%20cozy%20atmosphere&width=1600&height=700&seq=tv-cover-03&orientation=landscape',
    status: '已完结',
    updateInfo: '全20集',
    totalEpisodes: 20,
    currentEpisode: 20,
    director: '申源浩',
    cast: ['李惠利', '朴宝剑', '柳俊烈', '高庚杓', '李东辉'],
    region: '韩国',
    language: '韩语',
    genres: ['家庭', '青春', '爱情', '喜剧'],
    episodes: Array.from({ length: 20 }, (_, i) => ({
      id: `ep-3-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '90分钟',
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
    views: '2560万',
  },
  {
    id: '4',
    title: '繁花',
    englishTitle: 'Blossoms Shanghai',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 9.2,
    description: '九十年代的上海，人人争上游，阿宝也变成了宝总，成功过也失败过，在沪上弄潮儿女中留下一段传奇。',
    longDescription: '九十年代的上海，处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼，在黄河路上成为叱咤风云的宝总。他经历了股市的疯狂、外贸的繁荣、餐饮界的明争暗斗。在这座充满魅力的城市里，阿宝与至真园老板娘李李、外贸大楼汪小姐、夜东京的玲子等人之间，上演了一幕幕关于梦想、爱情和人生选择的故事。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20Blossoms%20Shanghai%20poster%2C%20elegant%20man%20in%201990s%20Shanghai%20style%20suit%2C%20neon%20lights%20and%20Bund%20skyline%20background%2C%20cinematic%20noir%20aesthetic%2C%20golden%20and%20deep%20red%20tones%2C%20vintage%20luxury%20film%20poster%20style&width=600&height=840&seq=tv-poster-04&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cityscape%20cinematic%20wide%20banner%2C%20the%20Bund%20at%20night%20with%20neon%20lights%2C%20Huangpu%20River%2C%20retro%20luxury%20aesthetic%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20film%20grain%20texture%2C%20nostalgic%20atmosphere&width=1600&height=700&seq=tv-cover-04&orientation=landscape',
    status: '已完结',
    updateInfo: '全30集',
    totalEpisodes: 30,
    currentEpisode: 30,
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    region: '中国大陆',
    language: '汉语普通话/沪语',
    genres: ['剧情', '年代', '爱情'],
    episodes: Array.from({ length: 30 }, (_, i) => ({
      id: `ep-4-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '50分钟',
    })),
    isHot: true,
    isNew: false,
    isRecommended: false,
    views: '1890万',
  },
  {
    id: '5',
    title: '庆余年第二季',
    englishTitle: 'Joy of Life Season 2',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 8.7,
    description: '范闲从北齐归来后，面对更加复杂的朝堂局势，在庆帝、陈萍萍等人的博弈中步步为营。',
    longDescription: '范闲从北齐归来后，面对更加复杂的朝堂局势，在庆帝、陈萍萍等人的博弈中步步为营。他一方面要应对长公主等人的暗算，一方面又要守护自己心爱之人。南庆的朝堂之上波诡云谲，监察院、太子、二皇子各方势力暗流涌动。范闲凭借自己的智慧和勇气，在这权力的漩涡中寻找属于自己的道路。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20Joy%20of%20Life%20poster%2C%20handsome%20man%20in%20ancient%20Chinese%20black%20robe%20holding%20sword%2C%20dramatic%20palace%20background%2C%20cinematic%20lighting%2C%20epic%20dark%20fantasy%20aesthetic%2C%20rich%20black%20and%20gold%20tones&width=600&height=840&seq=tv-poster-05&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20wide%20cinematic%20banner%2C%20grand%20throne%20room%20with%20dramatic%20lighting%2C%20epic%20historical%20fantasy%20atmosphere%2C%20dark%20and%20moody%20tones%20with%20gold%20accents%2C%20film%20quality%20cinematography&width=1600&height=700&seq=tv-cover-05&orientation=landscape',
    status: '已完结',
    updateInfo: '全36集',
    totalEpisodes: 36,
    currentEpisode: 36,
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    region: '中国大陆',
    language: '汉语普通话',
    genres: ['古装', '权谋', '喜剧'],
    episodes: Array.from({ length: 36 }, (_, i) => ({
      id: `ep-5-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '45分钟',
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
    views: '2150万',
  },
  {
    id: '6',
    title: '眼泪女王',
    englishTitle: 'Queen of Tears',
    category: '韩剧',
    categorySlug: 'hanju',
    year: 2024,
    rating: 8.6,
    description: '皇后集团财阀三代洪海仁与龙头里超市王子白贤宇经历一场惊险危机后，爱情奇迹般重新绽放的故事。',
    longDescription: '皇后集团财阀三代洪海仁与龙头里超市王子白贤宇，这对结婚三年的夫妻正经历着婚姻危机。海仁是百货女王，贤宇是法务理事，两人在婚姻中渐行渐远。直到海仁被诊断出绝症，贤宇决定在最后的日子里好好爱她。而在生死考验面前，两人重新发现了彼此的爱，演绎了一段感人至深的浪漫爱情。',
    poster: 'https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20poster%2C%20elegant%20couple%20in%20luxury%20clothing%2C%20woman%20in%20white%20dress%20man%20in%20black%20suit%2C%20soft%20romantic%20lighting%2C%20cherry%20blossom%20petals%2C%20dreamy%20cinematic%20aesthetic%2C%20pastel%20warm%20tones&width=600&height=840&seq=tv-poster-06&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20cinematic%20wide%20banner%2C%20cherry%20blossom%20avenue%20in%20spring%2C%20soft%20pink%20and%20warm%20golden%20light%2C%20romantic%20dreamy%20atmosphere%2C%20film%20quality%20cinematography%2C%20elegant%20and%20soft%20aesthetic&width=1600&height=700&seq=tv-cover-06&orientation=landscape',
    status: '已完结',
    updateInfo: '全16集',
    totalEpisodes: 16,
    currentEpisode: 16,
    director: '张英宇',
    cast: ['金秀贤', '金智媛', '朴成焄', '郭东延'],
    region: '韩国',
    language: '韩语',
    genres: ['爱情', '喜剧', '财阀'],
    episodes: Array.from({ length: 16 }, (_, i) => ({
      id: `ep-6-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '70分钟',
    })),
    isHot: false,
    isNew: false,
    isRecommended: true,
    views: '1560万',
  },
  {
    id: '7',
    title: '新闻女王',
    englishTitle: 'The Queen of News',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 8.5,
    description: '新闻主播文慧心凭借过硬的专业能力在SNK-NEWS中站稳脚跟，与各路对手展开职场较量。',
    longDescription: '文慧心是SNK-NEWS的当家女主播，凭借多年积累的专业能力和新闻嗅觉，在电视台激烈的竞争中脱颖而出。然而，新晋主播的崛起、管理层的变动、新闻伦理的挑战，都让她的职场之路充满波折。在这场没有硝烟的新闻战场中，文慧心不仅要守住自己的主播台，更要守住新闻人的底线。',
    poster: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20newsroom%20drama%20poster%2C%20professional%20woman%20news%20anchor%20in%20sharp%20suit%2C%20TV%20studio%20background%20with%20cameras%20and%20lights%2C%20modern%20urban%20professional%20aesthetic%2C%20dramatic%20studio%20lighting%2C%20cool%20professional%20tones&width=600&height=840&seq=tv-poster-07&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20TV%20newsroom%20studio%20cinematic%20wide%20banner%2C%20professional%20broadcasting%20equipment%20and%20control%20room%2C%20dramatic%20studio%20lighting%2C%20urban%20professional%20atmosphere%2C%20cool%20blue%20and%20silver%20tones%2C%20high%20tech%20broadcasting%20environment&width=1600&height=700&seq=tv-cover-07&orientation=landscape',
    status: '已完结',
    updateInfo: '全26集',
    totalEpisodes: 26,
    currentEpisode: 26,
    director: '钟澍佳',
    cast: ['佘诗曼', '马国明', '李施嬅', '高海宁'],
    region: '中国香港',
    language: '粤语/汉语普通话',
    genres: ['职场', '剧情', '女性'],
    episodes: Array.from({ length: 26 }, (_, i) => ({
      id: `ep-7-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '43分钟',
    })),
    isHot: false,
    isNew: false,
    isRecommended: false,
    views: '720万',
  },
  {
    id: '8',
    title: '排球少年！！',
    englishTitle: 'Haikyuu!!',
    category: '动漫',
    categorySlug: 'dongman',
    year: 2014,
    rating: 9.5,
    description: '身材矮小的日向翔阳在初中被嘲笑为"小不点"，但他凭借超强的弹跳力坚持排球梦想，高中加入乌野高中排球部。',
    longDescription: '日向翔阳在初中时看到电视上乌野高中排球部的"小巨人"比赛后，被深深震撼，从此迷上了排球。尽管初中排球部只有他一人，他仍然坚持训练。升入高中后，他如愿加入乌野高中排球部，却遇到了曾经在初中比赛中击败自己的天才二传手影山飞雄。两人从对手变成队友，共同带领乌野高中走向全国大赛。',
    poster: 'https://readdy.ai/api/search-image?query=Anime%20sports%20Haikyuu%20poster%20style%2C%20energetic%20orange%20haired%20boy%20in%20volleyball%20uniform%20jumping%2C%20dynamic%20action%20pose%2C%20volleyball%20court%20background%2C%20vibrant%20anime%20art%20style%2C%20orange%20and%20black%20color%20scheme%2C%20sports%20anime%20aesthetic&width=600&height=840&seq=tv-poster-08&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20volleyball%20match%20cinematic%20wide%20banner%2C%20indoor%20sports%20arena%20with%20bright%20lights%2C%20dynamic%20volleyball%20action%20scene%2C%20vibrant%20anime%20art%20style%2C%20orange%20and%20white%20color%20scheme%2C%20energetic%20atmosphere&width=1600&height=700&seq=tv-cover-08&orientation=landscape',
    status: '已完结',
    updateInfo: '全85集',
    totalEpisodes: 85,
    currentEpisode: 85,
    director: '满仲劝',
    cast: ['村濑步', '石川界人', '日野聪', '入野自由'],
    region: '日本',
    language: '日语',
    genres: ['运动', '热血', '青春', '校园'],
    episodes: Array.from({ length: 85 }, (_, i) => ({
      id: `ep-8-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '24分钟',
    })),
    isHot: false,
    isNew: false,
    isRecommended: true,
    views: '890万',
  },
  {
    id: '9',
    title: '黑暗荣耀',
    englishTitle: 'The Glory',
    category: '韩剧',
    categorySlug: 'hanju',
    year: 2023,
    rating: 9.1,
    description: '年少时期遭受校园暴力的文东恩，精心策划了一场针对当年施暴者的复仇计划。',
    longDescription: '文东恩在高中时期遭受了残酷的校园暴力，被迫退学后，她将所有痛苦化为动力，开始了一场长达十余年的复仇计划。她成为了施暴者女儿的班主任，一步步接近当年的施暴者们。在这场精密设计的复仇中，她遇到了愿意成为她刽子手的朱如炡，两人携手展开了一场痛快淋漓的复仇之旅。',
    poster: 'https://readdy.ai/api/search-image?query=Korean%20revenge%20drama%20The%20Glory%20poster%2C%20elegant%20woman%20in%20black%20dress%20with%20intense%20expression%2C%20dark%20moody%20atmosphere%2C%20chess%20pieces%20on%20table%2C%20cinematic%20noir%20aesthetic%2C%20deep%20shadows%20and%20warm%20highlights%2C%20mysterious%20and%20powerful&width=600&height=840&seq=tv-poster-09&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20dark%20drama%20cinematic%20wide%20banner%2C%20luxury%20modern%20apartment%20with%20dramatic%20shadow%20lighting%2C%20moody%20and%20mysterious%20atmosphere%2C%20dark%20luxury%20aesthetic%2C%20film%20noir%20style%2C%20deep%20contrast%20with%20warm%20accents&width=1600&height=700&seq=tv-cover-09&orientation=landscape',
    status: '已完结',
    updateInfo: '全16集',
    totalEpisodes: 16,
    currentEpisode: 16,
    director: '安吉镐',
    cast: ['宋慧乔', '李到晛', '林智妍', '廉惠兰'],
    region: '韩国',
    language: '韩语',
    genres: ['悬疑', '复仇', '剧情'],
    episodes: Array.from({ length: 16 }, (_, i) => ({
      id: `ep-9-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '55分钟',
    })),
    isHot: false,
    isNew: false,
    isRecommended: false,
    views: '1820万',
  },
  {
    id: '10',
    title: '完美世界',
    englishTitle: 'Perfect World',
    category: '动漫',
    categorySlug: 'dongman',
    year: 2023,
    rating: 8.4,
    description: '少年石昊出生于大荒，在石村长大，为寻找父母踏上修炼之路，凭借坚毅心性在大荒世界一步步变强。',
    longDescription: '石昊本是天生至尊，却被族兄石毅及其母亲夺走至尊骨，导致重病垂死。在父母的拼死保护下活了下来，被寄养在石村长大。为了寻找失踪的父母，石昊踏上了修炼之路。他在虚神界中闯荡，在百断山历练，一步步揭开上古的秘密，在追寻真相的过程中逐渐成长为独当一面的强者。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20Perfect%20World%20poster%2C%20young%20warrior%20boy%20with%20flowing%20black%20hair%20in%20ancient%20Chinese%20fantasy%20armor%2C%20epic%20mythical%20creatures%20background%2C%20vibrant%203D%20anime%20style%2C%20magical%20glowing%20effects%2C%20rich%20gold%20and%20crimson%20tones&width=600&height=840&seq=tv-poster-10&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20fantasy%20world%20wide%20banner%2C%20ancient%20mythical%20landscape%20with%20floating%20islands%20and%20magical%20auras%2C%20epic%20fantasy%20atmosphere%2C%20vibrant%203D%20anime%20style%2C%20golden%20and%20crimson%20color%20palette&width=1600&height=700&seq=tv-cover-10&orientation=landscape',
    status: '更新中',
    updateInfo: '更新至182集',
    totalEpisodes: 200,
    currentEpisode: 182,
    director: '汪成果',
    cast: ['锦鲤', '刘晴', '赵双'],
    region: '中国大陆',
    language: '汉语普通话',
    genres: ['玄幻', '热血', '冒险'],
    episodes: Array.from({ length: 200 }, (_, i) => ({
      id: `ep-10-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '20分钟',
    })),
    isHot: false,
    isNew: true,
    isRecommended: false,
    views: '650万',
  },
  {
    id: '11',
    title: '猎罪图鉴2',
    englishTitle: 'Under the Skin 2',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2025,
    rating: 8.1,
    description: '模拟画像师沈翊与刑警队长杜城再度联手，通过画像技术追踪连环案件背后隐藏的真相。',
    longDescription: '北江市发生了一系列离奇的案件，模拟画像师沈翊再次被刑警队长杜城紧急召回。沈翊凭借惊人的画像天赋，通过目击者模糊的记忆还原嫌疑人面貌，为案件侦破提供关键线索。两人从最初的不信任到默契配合，在追踪真相的过程中，不仅揭开了案件背后的惊天秘密，也直面了各自的过去和内心的恐惧。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20Under%20the%20Skin%20poster%2C%20man%20sketching%20portrait%20with%20intense%20focus%2C%20dark%20interrogation%20room%20background%2C%20mysterious%20suspense%20lighting%2C%20modern%20crime%20drama%20aesthetic%2C%20moody%20blue%20and%20warm%20highlights&width=600&height=840&seq=tv-poster-11&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20cinematic%20wide%20banner%2C%20police%20station%20investigation%20room%20with%20evidence%20board%2C%20dramatic%20moody%20lighting%2C%20modern%20urban%20crime%20scene%20aesthetic%2C%20suspenseful%20atmosphere%2C%20dark%20tones%20with%20blue%20accents&width=1600&height=700&seq=tv-cover-11&orientation=landscape',
    status: '更新中',
    updateInfo: '更新至20集/共28集',
    totalEpisodes: 28,
    currentEpisode: 20,
    director: '邢键钧',
    cast: ['檀健次', '金世佳', '张柏嘉', '朱嘉琦'],
    region: '中国大陆',
    language: '汉语普通话',
    genres: ['悬疑', '犯罪', '剧情'],
    episodes: Array.from({ length: 28 }, (_, i) => ({
      id: `ep-11-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '40分钟',
    })),
    isHot: true,
    isNew: true,
    isRecommended: true,
    views: '1100万',
  },
  {
    id: '12',
    title: '鬼灭之刃：柱训练篇',
    englishTitle: 'Demon Slayer: Hashira Training Arc',
    category: '动漫',
    categorySlug: 'dongman',
    year: 2024,
    rating: 9.3,
    description: '炭治郎等人在柱的指导下进行地狱般的特训，为与鬼舞辻无惨的最终决战做准备。',
    longDescription: '在与上弦之肆半天狗的激战后，炭治郎等人伤势痊愈。为了迎接与鬼舞辻无惨的最终决战，产屋敷耀哉命令所有鬼杀队成员在九柱的指导下进行强化训练。每位柱都以自己的方式对队员们进行严格的训练，炭治郎等人在这场地狱般的特训中不断突破自己的极限，实力得到飞跃般的提升。',
    poster: 'https://readdy.ai/api/search-image?query=Anime%20Demon%20Slayer%20poster%20style%2C%20young%20swordsman%20with%20green%20checkered%20haori%20holding%20katana%2C%20dramatic%20action%20pose%2C%20traditional%20Japanese%20training%20grounds%2C%20vibrant%20anime%20art%20with%20water%20breathing%20effects%2C%20dynamic%20color%20contrast&width=600&height=840&seq=tv-poster-12&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20Demon%20Slayer%20training%20arc%20cinematic%20wide%20banner%2C%20Japanese%20traditional%20dojo%20interior%20with%20sunlight%20streaming%20through%20windows%2C%20warriors%20training%20intensely%2C%20vibrant%20anime%20art%20style%2C%20dynamic%20action%20atmosphere%2C%20rich%20color%20contrast&width=1600&height=700&seq=tv-cover-12&orientation=landscape',
    status: '已完结',
    updateInfo: '全8集',
    totalEpisodes: 8,
    currentEpisode: 8,
    director: '外崎春雄',
    cast: ['花江夏树', '鬼头明里', '下野纮', '松冈祯丞'],
    region: '日本',
    language: '日语',
    genres: ['热血', '战斗', '奇幻'],
    episodes: Array.from({ length: 8 }, (_, i) => ({
      id: `ep-12-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '30分钟',
    })),
    isHot: false,
    isNew: true,
    isRecommended: true,
    views: '1780万',
  },
  {
    id: '13',
    title: '狂飙',
    englishTitle: 'The Knockout',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2023,
    rating: 9.4,
    description: '刑警安欣与黑恶势力高启强横跨二十年的正邪较量，展现扫黑除恶的艰辛历程。',
    longDescription: '2000年，刑警安欣在调查一起命案时，结识了菜市场卖鱼的高启强。二十年间，高启强从受欺负的鱼贩逐渐蜕变为京海市最大的黑恶势力头目，而安欣始终坚守警察的职责和正义的信念。在漫长的正邪较量中，两人的命运如棋局般交织。最终在全国扫黑除恶专项斗争中，高启强的犯罪集团被彻底打掉。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20The%20Knockout%20poster%2C%20two%20men%20facing%20each%20other%2C%20one%20in%20police%20uniform%20one%20in%20dark%20suit%2C%20intense%20confrontation%2C%20dark%20urban%20street%20background%2C%20cinematic%20crime%20thriller%20aesthetic%2C%20moody%20lighting&width=600&height=840&seq=tv-poster-13&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20cinematic%20wide%20banner%2C%20urban%20Chinese%20city%20street%20at%20night%20with%20neon%20lights%2C%20police%20cars%2C%20dramatic%20moody%20atmosphere%2C%20crime%20thriller%20aesthetic%2C%20dark%20and%20gritty%20urban%20landscape&width=1600&height=700&seq=tv-cover-13&orientation=landscape',
    status: '已完结',
    updateInfo: '全39集',
    totalEpisodes: 39,
    currentEpisode: 39,
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '吴刚', '张志坚'],
    region: '中国大陆',
    language: '汉语普通话',
    genres: ['剧情', '犯罪', '扫黑'],
    episodes: Array.from({ length: 39 }, (_, i) => ({
      id: `ep-13-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '45分钟',
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
    views: '3580万',
  },
  {
    id: '14',
    title: '冰雨火',
    englishTitle: 'Being a Hero',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 7.9,
    description: '禁毒警察吴振峰与缉毒队长陈宇联手，深入毒枭组织内部，展开惊心动魄的卧底行动。',
    longDescription: '吴振峰是一名经验丰富的禁毒警察，为了彻底摧毁横跨云缅边境的大型贩毒集团，他接受任务化名潜入贩毒组织内部。缉毒队长陈宇在外围配合，两人里应外合，与狡猾的毒枭斗智斗勇。在一次次生死考验中，吴振峰逐渐获得了毒枭的信任，但也面临着身份暴露的危险。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20anti%20drug%20police%20drama%20poster%2C%20undercover%20cop%20in%20leather%20jacket%20with%20serious%20expression%2C%20tropical%20border%20jungle%20background%2C%20action%20thriller%20aesthetic%2C%20dramatic%20lighting%2C%20warm%20and%20dark%20tones&width=600&height=840&seq=tv-poster-14&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20police%20undercover%20drama%20wide%20banner%2C%20tropical%20border%20jungle%20landscape%20at%20sunset%2C%20military%20vehicles%20on%20dirt%20road%2C%20action%20thriller%20atmosphere%2C%20dramatic%20cinematic%20lighting%2C%20warm%20golden%20hour%20tones&width=1600&height=700&seq=tv-cover-14&orientation=landscape',
    status: '已完结',
    updateInfo: '全32集',
    totalEpisodes: 32,
    currentEpisode: 32,
    director: '傅东育',
    cast: ['陈晓', '王一博', '王劲松', '刘奕君'],
    region: '中国大陆',
    language: '汉语普通话',
    genres: ['刑侦', '犯罪', '动作'],
    episodes: Array.from({ length: 32 }, (_, i) => ({
      id: `ep-14-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '45分钟',
    })),
    isHot: false,
    isNew: false,
    isRecommended: false,
    views: '590万',
  },
  {
    id: '15',
    title: '孤单又灿烂的神-鬼怪',
    englishTitle: 'Goblin',
    category: '韩剧',
    categorySlug: 'hanju',
    year: 2016,
    rating: 9.6,
    description: '为了结束永恒生命而需要人类新娘的鬼怪，与失去记忆的阴间使者以及自称"鬼怪新娘"的少女之间奇妙浪漫的故事。',
    longDescription: '高丽时期的大将军金侁因遭王的猜忌而遇害，死后成为拥有不死之身的鬼怪。为了结束无限循环的永生，他必须找到一位人类新娘。在寻找鬼怪新娘的过程中，他遇到了自称是鬼怪新娘的高三少女池恩倬。与此同时，他还与患有失忆症的阴间使者王黎住在同一屋檐下，三人的命运开始交织在一起。',
    poster: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20Goblin%20drama%20poster%2C%20man%20in%20long%20black%20coat%20with%20sword%2C%20young%20woman%20with%20red%20scarf%2C%20autumn%20maple%20leaves%2C%20cinematic%20fantasy%20aesthetic%2C%20warm%20golden%20and%20deep%20blue%20contrast%2C%20romantic%20atmosphere&width=600&height=840&seq=tv-poster-15&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20cinematic%20wide%20banner%2C%20autumn%20maple%20tree%20lined%20street%20in%20Quebec%2C%20golden%20sunset%20light%2C%20romantic%20fantasy%20atmosphere%2C%20dreamy%20cinematic%20aesthetic%2C%20warm%20golden%20and%20crimson%20leaves&width=1600&height=700&seq=tv-cover-15&orientation=landscape',
    status: '已完结',
    updateInfo: '全16集',
    totalEpisodes: 16,
    currentEpisode: 16,
    director: '李应福',
    cast: ['孔刘', '金高银', '李栋旭', '刘寅娜'],
    region: '韩国',
    language: '韩语',
    genres: ['奇幻', '爱情', '喜剧'],
    episodes: Array.from({ length: 16 }, (_, i) => ({
      id: `ep-15-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '75分钟',
    })),
    isHot: false,
    isNew: false,
    isRecommended: true,
    views: '3200万',
  },
  {
    id: '16',
    title: '遮天',
    englishTitle: 'Shrouding the Heavens',
    category: '动漫',
    categorySlug: 'dongman',
    year: 2024,
    rating: 8.2,
    description: '叶凡与同学们参加泰山毕业旅行时，意外被九龙拉棺带入北斗星域，开启了一段波澜壮阔的修仙之旅。',
    longDescription: '叶凡和同学们在泰山之巅参加毕业旅行时，天降九龙拉棺，将他们带到了浩瀚的北斗星域。在这片强者为尊的世界里，叶凡从一个小小的凡人开始，凭借坚毅的心性和过人的智慧，一步步踏上修炼之路。他闯禁地、夺造化、战天骄，在遮天蔽日的苍穹之下，书写属于自己的传奇。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20cultivation%20fantasy%20poster%2C%20young%20man%20in%20ancient%20Chinese%20white%20robe%20floating%20in%20starry%20sky%2C%20nine%20dragons%20pulling%20coffin%2C%20epic%20cosmic%20scale%2C%20vibrant%203D%20anime%20style%2C%20celestial%20purple%20and%20gold%20tones&width=600&height=840&seq=tv-poster-16&orientation=portrait',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20cosmic%20fantasy%20wide%20banner%2C%20starry%20universe%20with%20ancient%20Chinese%20mythical%20elements%2C%20nine%20dragons%20in%20space%2C%20epic%20scale%2C%20vibrant%203D%20anime%20style%2C%20purple%20and%20gold%20cosmic%20color%20palette&width=1600&height=700&seq=tv-cover-16&orientation=landscape',
    status: '更新中',
    updateInfo: '更新至56集',
    totalEpisodes: 104,
    currentEpisode: 56,
    director: '赵侠',
    cast: ['赵路', '刘北辰', '吴磊'],
    region: '中国大陆',
    language: '汉语普通话',
    genres: ['修仙', '玄幻', '冒险'],
    episodes: Array.from({ length: 104 }, (_, i) => ({
      id: `ep-16-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '22分钟',
    })),
    isHot: false,
    isNew: true,
    isRecommended: false,
    views: '480万',
  },
];

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '国产剧', slug: 'guochan' },
  { name: '韩剧', slug: 'hanju' },
  { name: '美剧', slug: 'meiju' },
  { name: '日剧', slug: 'riju' },
  { name: '动漫', slug: 'dongman' },
  { name: '综艺', slug: 'zongyi' },
];

export const hotTags = [
  '长相思', '庆余年', '狂飙', '繁花', '猎罪图鉴', '鬼灭之刃',
  '眼泪女王', '黑暗荣耀', '完美世界', '遮天', '排球少年', '新闻女王',
];

export const faqData = [
  {
    question: '夫妻影院的电视剧需要付费观看吗？',
    answer: '夫妻影院所有电视剧资源均为免费在线观看，无需注册会员即可享受高清流畅的追剧体验。我们致力于为广大剧迷提供优质的免费观影服务。',
  },
  {
    question: '为什么有的电视剧播放会卡顿？',
    answer: '播放卡顿可能与您的网络环境有关。建议您检查网络连接状况，或尝试切换播放线路。夫妻影院提供多线路备选，确保您能获得流畅的观影体验。',
  },
  {
    question: '更新频率是怎样的？在播剧集什么时候更新？',
    answer: '夫妻影院每日更新最新剧集资源。在播热门电视剧通常与电视台同步更新，大部分剧集播出后2小时内即可上线。具体更新时间以各剧集实际播出时间为准。',
  },
  {
    question: '可以在手机上观看吗？支持投屏吗？',
    answer: '夫妻影院全面支持手机、平板、电脑等多种设备观看。同时支持DLNA和AirPlay投屏功能，可以把电视剧投屏到电视大屏上享受更震撼的观影体验。',
  },
  {
    question: '如何搜索想看的电视剧？',
    answer: '您可以通过首页顶部的搜索框直接输入剧名进行搜索，也可以按照国产剧、韩剧、动漫等分类浏览。热门标签也能帮助您快速找到受欢迎的电视剧。',
  },
];

export const siteInfo = {
  name: '夫妻影院',
  slogan: '追剧时光，有你有我',
  description: '夫妻影院是国内领先的免费电视剧在线观看平台，提供国产剧、韩剧、美剧、日剧、动漫等海量高清影视资源。每日更新最新剧集，支持多设备观看，致力于为每一位剧迷打造极致的追剧体验。',
  founded: '2018年',
  email: 'contact@fuqicinema.com',
  views: '日均千万级播放量',
};